module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addProduct":"Artikel hinzufügen","products":"Artikel"},"en":{"addProduct":"Add product","products":"Products"}}')
  delete Component.options._Ctor
}
